import classNames from 'classnames';
import React from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
    {
        container: {
            position: 'relative',
            width: '100%',
            height: '50vh',
            marginBottom: 20,

            '@media (min-width: 1024px)': {
                // height: 'auto',
                maxWidth: 756,
                // paddingBottom: '65.47%',
                height: '52vh',
                width: '72vh',
                margin: '0 auto 50px',
            },
        },
        inner: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
        },

        btnLeft: {
            position: 'absolute',
            top: '50%',
            left: -80,
            transform: 'translateY(-50%)',
        },

        btnRight: {
            position: 'absolute',
            top: '50%',
            right: -80,
            transform: 'translateY(-50%)',
        },

        image: {
            zIndex: 1,
            width: 'calc(100% - 64px)',
            height: 'calc(100% - 64px)',
            position: 'absolute',
            left: 0,
            top: 0,
            // opacity: 0,
            objectFit: 'cover',
            objectPosition: 'center',
            borderRadius: 8,
            transition:
                'transform 0.3s ease-in-out, opacity 0.3s ease-in-out, z-index 0.3s step-end',
        },

        active: {
            opacity: 1,
            transform: 'translate(32px, 64px)',
            zIndex: 10,
        },

        p1: {
            opacity: 1,
            transform: 'translate(48px, 32px)',
            zIndex: 8,
            transition:
                'transform 0.3s ease-in-out, opacity 0.3s ease-in-out, z-index 0.3s step-end',
        },

        p2: {
            opacity: 1,
            transform: 'translate(48px, 32px)',
            zIndex: 8,
            transition:
                'transform 0.3s ease-in-out, opacity 0.3s ease-in-out, z-index 0.3s step-end',
        },

        n1: {
            opacity: 1,
            filter: 'grayscale(100%) brightness(0.4)',
            transform: 'translate(0, 48px)',
            zIndex: 9,
        },

        n2: {
            opacity: 1,
            filter: 'grayscale(100%) brightness(0.4)',
            transform: 'translate(64px, 16px)',
            zIndex: 8,
        },
    },
    { name: 'Gallery' }
);

export default function Gallery({ active, images }) {
    const classes = useStyles(0);

    const p2 = (active + images.length - 2) % images.length;
    const p1 = (active + images.length - 1) % images.length;
    const n1 = (active + 1) % images.length;
    const n2 = (active + 2) % images.length;

    return (
        <div className={classes.container}>
            <div className={classes.inner}>
                {images.map((item, index) => (
                    <img
                        key={index}
                        className={classNames(
                            classes.image,
                            index === p2 && images.length > 3 ? classes.p2 : '',
                            index === p1 ? classes.p1 : '',
                            index === active ? classes.active : '',
                            index === n1 ? classes.n1 : '',
                            index === n2 && images.length > 3 ? classes.n2 : ''
                        )}
                        src={item}
                    />
                ))}
            </div>
        </div>
    );
}
